"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e = require("../cjs/Icon/IconBase.js"),
  r = require("../cjs/Icon/utils.js"),
  a = require("react/jsx-runtime");
var s = function s(_s) {
  var t = _s.ariaHidden,
    i = _s.ariaLabel,
    l = _s.size,
    o = _s.surface,
    c = _s.id,
    n = _s.title;
  return a.jsx(e.default, {
    ariaHidden: t,
    ariaLabel: i,
    color: r.getIconColor(_s),
    name: "close",
    id: c,
    size: l,
    surface: o,
    svgContent: a.jsx(a.Fragment, {
      children: a.jsx("path", {
        d: "M11.59,10.8l7.11,7.1-.8.8-7.1-7.11L3.7,18.7l-.8-.8L10,10.8,2.9,3.7l.8-.8L10.8,10,17.9,2.9l.8.8Z"
      })
    }),
    title: n,
    viewBox: "0 0 21.6 21.6"
  });
};
s.defaultProps = e.defaultProps, s.displayName = "VDS_Icon", exports.default = s;